<template>
  <div class="admin-container">
    <div class="menu">
      <div class="logged-in-user">
        <img :src="authUser.avatar" :alt="authUser.name" />
        <Dropdown :options="userOptions">
          <span>{{ authUser.name }}</span>
        </Dropdown>
      </div>
      <!-- <Dropdown openOnHover :options="options" v-model="selected">
        <Button type="outlined">Menu</Button>
      </Dropdown> -->
    </div>
    <slot></slot>
    <Footer v-if="!isMobile && !isTablet" />
    <MobileFooter v-else />
  </div>
</template>

<script lang="ts">
import Footer from "@/components/layout/Footer.vue"
import MobileFooter from "@/components/layout/MobileFooter.vue"
import Dropdown, { DropdownOption } from "@/components/uikit/Dropdown.vue"
import { useWindowSize } from "@/composables/useWindowSize"
// import Button from "@/components/uikit/Button.vue"
import { defineComponent } from "vue"
import { mapActions } from "vuex"

export default defineComponent({
  name: "ModeratorLayout",
  components: { Footer, MobileFooter, Dropdown }, //  Button,
  data() {
    return {
      userOptions: [
        {
          label: "Logout",
          key: "logout",
          onClick: this.logout,
        },
      ] as DropdownOption[],
    }
  },
  setup() {
    const { isMobile, isTablet } = useWindowSize()

    return { isMobile, isTablet }
  },
  computed: {
    authUser() {
      return this.$store.getters["auth/user"]
    },
  },
  methods: {
    ...mapActions({
      logout: "auth/logout",
    }),
  },
  beforeMount() {
    if (!this.authUser.is_moderator) {
      this.$router.push("/")
    } else {
      this.$router.push("/moderator-account")
    }
  },
})
</script>
<style lang="scss" scoped>
.admin-container {
  display: flex;
  justify-content: center;
  padding: 40px;

  .menu {
    position: absolute;
    top: 20px;
    right: 20px;
  }
}
</style>
